import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { Project } from './project.model';
import { projects } from './projects';

@Injectable()
export class ProjectService {
    private projects: BehaviorSubject<Project[]> = new BehaviorSubject<Project[]>(projects);

    public getProjectBySlug(slug: string): Promise<Project> {
        return new Promise<Project>((resolve, reject) => {
            resolve(this.getProjects().getValue().find(a => a.slug === slug));
        });
    }

    public getProjects(): BehaviorSubject<Project[]> {
        return this.projects;
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/project.service.ts